module.exports = __webpack_public_path__ + "img/paishui (5).298c9c45.png";